import React, { useState } from "react";
import { Box, Slider, IconButton, Collapse } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeMuteIcon from "@mui/icons-material/VolumeMute";
import VolumeDownIcon from "@mui/icons-material/VolumeDown";

interface VolumeControlProps {
  isMuted: boolean;
  toggleMute: () => void;
  volume: number;
  setVolume: (volume: number) => void;
  disabled?: boolean;
}

const VolumeControl: React.FC<VolumeControlProps> = ({ isMuted, toggleMute, volume, setVolume, disabled = false }) => {
  const [isSliderVisible, setIsSliderVisible] = useState(false);

  // ボリュームアイコンを選択
  const getVolumeIcon = () => {
    if (isMuted || volume === 0) return <VolumeOffIcon />;
    if (volume < 0.3) return <VolumeMuteIcon />;
    if (volume < 0.7) return <VolumeDownIcon />;
    return <VolumeUpIcon />;
  };

  // ボリューム変更ハンドラ
  const handleVolumeChange = (_event: Event, newValue: number | number[]) => {
    const volumeValue = newValue as number;
    setVolume(volumeValue);

    // 音量が0より大きくなった場合で、かつミュート中の場合はミュートを解除
    if (volumeValue > 0 && isMuted) {
      toggleMute();
    }
  };

  return (
    <Box
      sx={{ display: "flex", alignItems: "center" }}
      onMouseEnter={() => setIsSliderVisible(true)}
      onMouseLeave={() => setIsSliderVisible(false)}
    >
      <IconButton onClick={toggleMute} disabled={disabled} size="small" aria-label="ミュート切り替え">
        {getVolumeIcon()}
      </IconButton>
      <Collapse in={isSliderVisible} timeout="auto" unmountOnExit orientation="horizontal">
        <Box sx={{ width: 100, ml: 1 }}>
          <Slider
            value={isMuted ? 0 : volume}
            onChange={handleVolumeChange}
            min={0}
            max={1}
            step={0.01}
            size="small"
            aria-labelledby="volume-slider"
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default VolumeControl;
